export default __webpack_public_path__ + "static/media/072-bonaire.fb147477.svg";